import React, { useContext, useState } from 'react';
import { View, StyleSheet, Image, Text, TouchableOpacity, Platform } from 'react-native';
import { Drawer, List, Colors } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { Ionicons } from '@expo/vector-icons';
import { AuthContext } from '../context/AuthProvider';
import FontSizes from '../constants/FontSizes';
import { MainColors } from '../constants/Colors';
import SwitchOrganizationModal from './components/SwitchOrganizationModal';
import OrganizationLogo from './components/OrganizationLogo';

const DrawerContent = ({ navigation, setDrawerOpen }) => {
    const { signOut, isSuperDuperAdmin, isAdminForOrganization } = useContext(AuthContext);

    const [isOrganizationModalVisible, setIsOrganizationModalVisible] = useState(false);

    const onBallotsPressedHandler = () => {
        navigation.navigate("BallotsDashboard");
        setDrawerOpen(false);
    }

    const onResultsPressedHandler = () => {
        navigation.navigate("ResultsDashboard");
        setDrawerOpen(false);
    }

    const onAdminBallotsPressed = () => {
        navigation.navigate("AdminBallotsDashboard");
        setDrawerOpen(false);
    }

    const onAdminUsersPressed = () => {
        navigation.navigate("AdminUsersDashboard");
        setDrawerOpen(false);
    }

    const onSuperDuperAdminOrganizationsPressed = () => {
        navigation.navigate("SuperDuperAdminOrganizationsDashboard");
        setDrawerOpen(false);
    }

    const onSettingsPressed = () => {
        navigation.navigate("SettingsDashboard");
        setDrawerOpen(false);
    }

    return (
        <View style={styles.container}>
            <View style={styles.organizationContainer}>
                <View style={{ marginTop: 20 }}>
                    <OrganizationLogo />
                </View>

                {/* TODO: if there is more than one Organization for the user, display the switch button */}
                {/* otherwise hide it if there is only one */}
                <TouchableOpacity style={styles.switchOrganizationButton}
                    onPress={() => { setIsOrganizationModalVisible(true) }}>
                    <Text style={styles.switchOrgText}>Switch Organization</Text>
                </TouchableOpacity>
            </View>
            <SwitchOrganizationModal
                visible={isOrganizationModalVisible}
                onModalBackgroundPressed={() => setIsOrganizationModalVisible(false)}
                onCloseIconPressed={() => setIsOrganizationModalVisible(false)}
            />
            <View style={styles.top}>
                <Drawer.Section style={styles.firstDrawerSection}>
                    <Drawer.Item
                        icon={({ color, size }) => (
                            <Icon
                                name="vote"
                                color={color}
                                size={size}
                            />
                        )}
                        label="Ballots"
                        onPress={onBallotsPressedHandler}
                        theme={{
                            fonts: { medium: { fontSize: 16, opacity: 1, color: '#000', fontWeight: '400' } }
                        }}
                        style={styles.link}
                    />
                </Drawer.Section>
                <Drawer.Section>
                    <Drawer.Item
                        icon={({ color, size }) => (
                            <Icon
                                name="clipboard-text"
                                color={color}
                                size={size}
                            />
                        )}
                        label="Results"
                        onPress={onResultsPressedHandler}
                        theme={{
                            fonts: { medium: { fontSize: 16, opacity: 1, color: '#000', fontWeight: '400' } }
                        }}
                        style={styles.link}
                    />
                </Drawer.Section>
                {
                    (isAdminForOrganization || isSuperDuperAdmin) &&
                    <Drawer.Section>
                        <List.Accordion
                            theme={{}}
                            style={{ backgroundColor: '#fff' }}
                            title="Admin Dashboard"
                            left={() => (
                                <List.Icon
                                    style={styles.adminDashboardIcon}
                                    icon="account-hard-hat"
                                    color='#000000ad'
                                    size={24}
                                />
                            )}
                            titleStyle={styles.link}
                        >
                            <List.Item style={styles.accordianListItem} titleStyle={styles.link}
                                title="Users" onPress={onAdminUsersPressed} />
                            <List.Item style={styles.accordianListItem} titleStyle={styles.link}
                                title="Ballots" onPress={onAdminBallotsPressed} />
                            {isSuperDuperAdmin &&
                                <List.Item style={styles.accordianListItem} titleStyle={styles.link}
                                    title="Organizations" onPress={onSuperDuperAdminOrganizationsPressed} />
                            }
                        </List.Accordion>
                    </Drawer.Section>
                }

                <Drawer.Section>
                    <Drawer.Item
                        icon={({ color, size }) => (
                            <Ionicons name="settings-sharp" size={size} color={color} />
                        )}
                        label="Settings"
                        onPress={onSettingsPressed}
                        theme={{
                            fonts: { medium: { fontSize: 16, opacity: 1, color: '#000', fontWeight: '400' } }
                        }}
                        style={styles.link}
                    />
                </Drawer.Section>
            </View>

            <View style={styles.bottom}>
                <Drawer.Item
                    icon={({ color, size }) => (
                        <Icon
                            name="exit-to-app"
                            color={color}
                            size={size}
                        />
                    )}
                    label="Sign Out"
                    onPress={() => signOut()}
                    theme={{
                        fonts: { medium: { fontSize: 16, opacity: 1, color: '#000', fontWeight: '400' } }
                    }}
                    style={styles.link}
                />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: "#fff",
        flex: 1,
        borderRightColor: Platform.OS === 'web' ? '#f2f2f2' : null,
        borderRightWidth: Platform.OS === 'web' ? 6 : null,
        minWidth: 258
    },
    link: {
        fontWeight: '400',
        fontSize: 16,
        color: '#000',
        opacity: 1,
    },
    organizationContainer: {
        alignItems: 'center',
        padding: 20,
        borderBottomColor: MainColors.faintGray,
        borderBottomWidth: 0.5
    },
    switchOrganizationButton: {
        marginTop: 20,
        flexDirection: 'row',
        alignItems: 'center'
    },
    switchOrgText: {
        fontSize: FontSizes.medium,
        color: MainColors.primary,
        fontWeight: '400'
    },
    top: {
        flexGrow: 1
    },
    firstDrawerSection: {
        paddingTop: 8
    },
    bottom: {
    },
    adminDashboardIcon: {
        marginVertical: 0,
        marginRight: 15,
        marginLeft: 3,
        fontSize: 16,
    },
    accordianListItem: {
        color: '#000',
        fontSize: 14,
        marginLeft: 20,
    },
});

export default DrawerContent;